require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./news-why-downsizers-are-flocking-to-melbournes-inner-city.json") })
        }
      }, "path---news-why-downsizers-are-flocking-to-melbournes-inner-city");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---news-why-downsizers-are-flocking-to-melbournes-inner-city!./.cache/json/news-why-downsizers-are-flocking-to-melbournes-inner-city.json
// module id = 865
// module chunks = 231608221292675